/** A person's own sidebar: the profiles they starred and filed, the folds they opened, and what they used lately. */

/** A category a person made to file profiles under. Nobody else sees it. */
export interface SidebarCategory {
	id: string;
	name: string;
}

/** A category's name is trimmed, then 1 to this many characters. */
export const CATEGORY_NAME_MAX = 40;

/** A person's use of one profile over the last 30 days. */
export interface ProfileUse {
	profile: string;
	/** Distinct conversations the person sent a message in. */
	conversations: number;
	/** The person's latest message there. */
	lastAt: number;
}

/** A fold the person opened: one of their categories, Other (`category:other`), or a project in a profile's list. */
export type ExpandedKey = `category:${string}` | `project:${string}`;

/** Other's fold: the profiles the person filed under none of their categories. */
export const OTHER_KEY: ExpandedKey = "category:other";

export function categoryKey(id: string): ExpandedKey {
	return `category:${id}`;
}

export function projectKey(id: string): ExpandedKey {
	return `project:${id}`;
}

export interface SidebarView {
	/** Starred profiles, in the order they were starred. */
	stars: string[];
	/** The person's categories, in their order. */
	categories: SidebarCategory[];
	/** Profile to category id. A profile with none is in Other. */
	placements: Record<string, string>;
	/** Every fold not listed is folded. */
	expanded: ExpandedKey[];
	uses: ProfileUse[];
}
